module.exports = __webpack_public_path__ + "img/terpercaya.95ac4426.png";